import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20streetwear%20fashion%20scene%20with%20sneakers%20hoodies%20and%20accessories%20styled%20on%20a%20concrete%20urban%20backdrop%2C%20moody%20cinematic%20lighting%2C%20deep%20teal%20and%20amber%20tones%2C%20premium%20ecommerce%20hero%20photography&width=1600&height=900&seq=hero-bg-02&orientation=landscape&nocache=true"
          alt="Fashion products background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-24 pb-16">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white/90 text-sm font-medium mb-6">
            <i className="ri-shield-check-line text-accent-400" />
            {t('trust_text')}
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-white leading-tight mb-6">
            {t('hero_title')}
          </h1>

          <p className="text-lg md:text-xl text-white/85 max-w-2xl mx-auto leading-relaxed mb-10">
            {t('hero_subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors text-base whitespace-nowrap"
            >
              <i className="ri-external-link-line" />
              {t('explore_spreadsheet')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-medium rounded-lg hover:bg-white/20 transition-colors text-base whitespace-nowrap border border-white/30"
            >
              <i className="ri-shopping-cart-line" />
              {t('buy_now')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}